/* @flow */

import { makeListLink } from './utils';

export default makeListLink({ pathname: '/auth', children: 'auth' });



// WEBPACK FOOTER //
// ./src/packages/@ncigdc/components/Links/AuthLink.js